module.exports = __webpack_public_path__ + "static/img/logo.5a5707e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 45